<template>
  <el-dialog title="开具增值税发票确认书" :visible.sync="dialogVisible" :before-close="handleClose" class="invoice-notice-dialog" :close-on-press-escape="false" :close-on-click-modal="false" ref="dialog" width="700px" :append-to-body="true" :show-close="false">
    <div class="notice-content">
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;购买者个人在提出申请开具企业抬头的发票时，则同时表明购买者本人承诺其本次购买行为是代表本次申请开具的增值税发票所示购买方企业进行，本次所支付的款项是代其本次申请开具的增值税发票所示购买方企业进行支付，而非购买者本人个人消费。
      <br><br>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;根据国家发票管理办法以及其他相关税务规定，任何单位和个人不得要求他人为自己开具与实际经营业务情况不符的增值税发票【包括但不限于（1）在没有采购货物或者没有购买劳务、服务的情况下要求他人为自己开具增值税发票；（2）虽有采购货物或者接受应税劳务、服务但要求他人为自己开具数量或金额与实际情况不符的增值税发票】，否则属于“虚开增值税发票”。
      <br><br>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;请充分了解上述承诺以及各项相关管理规定，并确认仅就我司已提供的服务索取发票。
    </div>
    <el-button class="invoice-notice-btn" @click="handleSubmit">我已充分了解并确认上述信息</el-button>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    checkNotice: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  watch: {
    value: {
      handler(val) {
        this.dialogVisible = val
      },
      immediate: true
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
      this.$emit('input', false)
    },
    handleSubmit() {
      this.dialogVisible = false
      this.$emit('input', false)
      this.$emit('update:checkNotice', true)
    }
  }
}
</script>

<style scoped lang="scss">
.notice-content {
  margin-bottom: 26px;
  font-size: 14px;
  color: #333333;
  line-height: 22px;
}
</style>
<style lang="scss">
  .invoice-notice-dialog {
    .el-dialog__header {
      border-bottom: 1px solid #D2D2D2;
      height: 63px;
      text-align: center;
    }
    .el-dialog__body {
      padding: 41px 54px 36px 50px;
    }
    .invoice-notice-btn {
      width: 220px;
      height: 32px;
      background: #CA4300;
      border-radius: 3px;
      line-height: 1;
      padding: 0;
      color: #fff;
      margin: auto;
      display: block;
    }
  }
</style>
